import { BaseSystemModel, Guid, RecursivePartial } from '@models/base';

export class WorkflowBrief extends BaseSystemModel {
    orgId!: Guid;
    projectId!: Guid;
    name: string = '';
    description?: string;
    isMain?: boolean;

    constructor(json?: RecursivePartial<WorkflowBrief>) {
        super(json);
        this.parseWorkflowBrief(json || {});
    }

    parse(json: RecursivePartial<WorkflowBrief>): WorkflowBrief {
        super.parse(json);
        this.parseWorkflowBrief(json);
        return this;
    }

    private parseWorkflowBrief(json: RecursivePartial<WorkflowBrief>): void {
        WorkflowBrief.assignFields(this, json, [
            'orgId',
            'projectId',
            'name',
            'description',
            'isMain',
        ]);
    }
}
